import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BoxWrapper, Button, Modal } from 'components/Base';
import { linkColor } from 'utils/colors';
import Icons from 'components/Icons';
import EmptyState from 'components/Base/EmptyState/EmptyState';
import api from 'api';
import { Notify } from 'utils';

interface ExistingAdvancedFiltersModalProps {
  isModalOpen: boolean;
  onClose: Function;
  setFilters: Function;
}

const ExistingAdvancedFiltersModal = ({
  isModalOpen,
  onClose,
  setFilters
}: ExistingAdvancedFiltersModalProps) => {
  const [existingFilters, setExistingFilters] = useState({} as any);
  const useStyles = makeStyles(() =>
    createStyles({
      modal: {
        width: '500px',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '20px'
      },
      row: {
        display: 'flex',
        alignItems: 'baseline'
      },
      label: {
        width: '50%'
      },
      value: {
        fontWeight: 600
      },
      link: {
        textDecoration: 'none',
        color: linkColor,
        '&:hover': {
          textDecoration: 'underline'
        }
      }
    })
  );

  const classes = useStyles();

  useEffect(() => {
    api.getAdvancedFilterSets().then((response: any) => {
      setExistingFilters(response.data.results);
    });
  }, [isModalOpen]);

  return (
    <Modal isOpen={isModalOpen} closeModalFunc={() => onClose()}>
      <BoxWrapper title="Existing Filters" closeModal={() => onClose()}>
        <div className={classes.modal}>
          {existingFilters.length > 0 ? (
            existingFilters.map((filter: any, index: number) => (
              <div
                key={index}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {filter.name}{' '}
                <div style={{ marginLeft: 'auto' }}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      justifyContent: 'flex-end',
                      gap: '10px'
                    }}
                  >
                    <div
                      className="cipThresholdDelete"
                      onClick={() => {
                        api.deleteAdvancedFilter(filter.id).then(() => {
                          Notify.success(
                            `You have successfully deleted ${filter.name}.`
                          );
                          onClose();
                        });
                      }}
                    >
                      <Icons.DeleteIcon />
                    </div>
                    <Button
                      variant="contained"
                      color="secondary"
                      type="submit"
                      size="medium"
                      onClick={() => {
                        setFilters(filter);
                        onClose();
                      }}
                      style={{ marginLeft: '1rem' }}
                    >
                      Set Filter
                    </Button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <EmptyState title="No existing filters" description="" />
          )}
        </div>
      </BoxWrapper>
    </Modal>
  );
};

export default ExistingAdvancedFiltersModal;
